/**
 * Hook truy cập AuthContext — cung cấp user, login, logout, refreshUser...
 *
 * Bắt buộc dùng bên trong AuthProvider; ném lỗi nếu gọi ngoài provider.
 */
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

/**
 * Truy cập context xác thực toàn ứng dụng.
 * @returns {import('../context/AuthContext').AuthContextValue}
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
